import {
  Globe, ShoppingCart, Search, Megaphone, Smartphone, MonitorSmartphone, RefreshCw, LayoutTemplate, Store, Code2, Briefcase,
  Wrench, Gauge, MousePointerClick, Share2, Workflow, AppWindow, Wallet, Headset, ShieldCheck, PanelsTopLeft, ListTree,
  MessagesSquare, ScanBarcode, Layers, Star, Quote,
} from "lucide-react";

const ICONS = {
  Globe, ShoppingCart, Search, Megaphone, Smartphone, MonitorSmartphone, RefreshCw, LayoutTemplate, Store, Code2, Briefcase,
  Wrench, Gauge, MousePointerClick, Share2, Workflow, AppWindow, Wallet, Headset, ShieldCheck, PanelsTopLeft, ListTree,
  MessagesSquare, ScanBarcode, Layers,
};
const TONES = ["bg-lime text-ink", "bg-sand text-ink", "bg-ink text-lime", "bg-[#DCE5D7] text-ink"];

export const Stars = ({ count = 5 }) => (
  <span className="flex items-center gap-0.5" role="img" aria-label={`${count} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className={`h-4 w-4 ${i < count ? "fill-[#E8A317] text-[#E8A317]" : "text-ink/20"}`} aria-hidden />
    ))}
  </span>
);

export const TestimonialCard = ({ t, index = 0, className = "" }) => {
  const Icon = ICONS[t.icon] || Quote;
  return (
    <figure className={`card-base flex h-full flex-col p-6 md:p-7 ${className}`} data-testid={`testimonial-${index}`}>
      <div className="flex items-center justify-between">
        <Stars count={t.stars} />
        <Quote className="h-6 w-6 text-ink/15" aria-hidden />
      </div>
      <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-ink/80">{t.text}</blockquote>
      <figcaption className="mt-6 flex items-center gap-3 border-t border-ink/10 pt-5">
        <span className={`grid h-12 w-12 shrink-0 place-items-center rounded-full ${TONES[index % TONES.length]}`} aria-hidden>
          <Icon className="h-5 w-5" strokeWidth={1.8} />
        </span>
        <span>
          <span className="block font-display text-base font-semibold text-ink">{t.name}</span>
          <span className="block text-sm text-ink/65">{t.service}</span>
        </span>
      </figcaption>
    </figure>
  );
};
